// import { ModulesActionTypes } from './constants';

// export type Module = {
//     module_id: string;
//     module_name: string;
//     description: string;
//     is_active: boolean;
//     created_at?: string;
//     updated_at?: string;
// };

// export type ModuleCreate = {
//     module_name: string;
//     description: string;
//     is_active: boolean;
// };

// export type ModuleUpdate = {
//     module_id: string;
//     module_name?: string;
//     description?: string;
//     is_active?: boolean;
// };

// export type ModuleUpdateStatus = {
//     module_id: string;
//     status: 'active' | 'inactive';
// };

// export type ModulesAction =
//     | { type: ModulesActionTypes.MODULE_LIST }
//     | { type: ModulesActionTypes.MODULE_LIST_SUCCESS; payload: Module[] }
//     | { type: ModulesActionTypes.MODULE_LIST_ERROR; payload: { error: string } }
//     | { type: ModulesActionTypes.MODULE_ADD; payload: ModuleCreate }
//     | { type: ModulesActionTypes.MODULE_ADD_SUCCESS; payload: { message: string } }
//     | { type: ModulesActionTypes.MODULE_ADD_ERROR; payload: { error: string } }
//     | { type: ModulesActionTypes.MODULE_UPDATE; payload: ModuleUpdate }
//     | { type: ModulesActionTypes.MODULE_UPDATE_SUCCESS; payload: { message: string } }
//     | { type: ModulesActionTypes.MODULE_UPDATE_ERROR; payload: { error: string } }
//     | { type: ModulesActionTypes.MODULE_UPDATE_STATUS; payload: ModuleUpdateStatus }
//     | { type: ModulesActionTypes.MODULE_UPDATE_STATUS_SUCCESS; payload: { message: string } }
//     | { type: ModulesActionTypes.MODULE_UPDATE_STATUS_ERROR; payload: { error: string } }
//     | { type: ModulesActionTypes.MODULE_DELETE; payload: { module_id: string } }
//     | { type: ModulesActionTypes.MODULE_DELETE_SUCCESS; payload: { message: string } }
//     | { type: ModulesActionTypes.MODULE_DELETE_ERROR; payload: { error: string } };

// export const moduleList = (): ModulesAction => ({
//     type: ModulesActionTypes.MODULE_LIST,
// });

// export const moduleListSuccess = (modules: Module[]): ModulesAction => ({
//     type: ModulesActionTypes.MODULE_LIST_SUCCESS,
//     payload: modules,
// });

// export const moduleListError = (error: string): ModulesAction => ({
//     type: ModulesActionTypes.MODULE_LIST_ERROR,
//     payload: { error },
// });

// export const moduleAdd = (data: ModuleCreate): ModulesAction => ({
//     type: ModulesActionTypes.MODULE_ADD,
//     payload: data,
// });

// export const moduleAddSuccess = (message: string): ModulesAction => ({
//     type: ModulesActionTypes.MODULE_ADD_SUCCESS,
//     payload: { message },
// });

// export const moduleAddError = (error: string): ModulesAction => ({
//     type: ModulesActionTypes.MODULE_ADD_ERROR,
//     payload: { error },
// });

// export const moduleUpdate = (data: ModuleUpdate): ModulesAction => ({
//     type: ModulesActionTypes.MODULE_UPDATE,
//     payload: data,
// });

// export const moduleUpdateSuccess = (message: string): ModulesAction => ({
//     type: ModulesActionTypes.MODULE_UPDATE_SUCCESS,
//     payload: { message },
// });

// export const moduleUpdateError = (error: string): ModulesAction => ({
//     type: ModulesActionTypes.MODULE_UPDATE_ERROR,
//     payload: { error },
// });

// export const moduleUpdateStatus = (data: ModuleUpdateStatus): ModulesAction => ({
//     type: ModulesActionTypes.MODULE_UPDATE_STATUS,
//     payload: data,
// });

// export const moduleUpdateStatusSuccess = (message: string): ModulesAction => ({
//     type: ModulesActionTypes.MODULE_UPDATE_STATUS_SUCCESS,
//     payload: { message },
// });

// export const moduleUpdateStatusError = (error: string): ModulesAction => ({
//     type: ModulesActionTypes.MODULE_UPDATE_STATUS_ERROR,
//     payload: { error },
// });

// export const moduleDelete = (module_id: string): ModulesAction => ({
//     type: ModulesActionTypes.MODULE_DELETE,
//     payload: { module_id },
// });

// export const moduleDeleteSuccess = (message: string): ModulesAction => ({
//     type: ModulesActionTypes.MODULE_DELETE_SUCCESS,
//     payload: { message },
// });

// export const moduleDeleteError = (error: string): ModulesAction => ({
//     type: ModulesActionTypes.MODULE_DELETE_ERROR,
//     payload: { error },
// });

// import { ModulesActionTypes } from './constants';

// // ---------------- Types ----------------
// export interface Module {
//     module_id: string;
//     module_name: string;
//     description: string;
//     is_active: boolean;
//     created_at?: string;
//     updated_at?: string;
// }

// // Success payloads
// export type ModuleListSuccess = Module[];
// export type ModuleMessage = { message: string };

// // ---------------- Action Definitions ----------------
// export interface ModuleListAction {
//     type: ModulesActionTypes.MODULE_LIST;
//     payload?: any; // optional filter params
// }

// export interface ModuleListSuccessAction {
//     type: ModulesActionTypes.MODULE_LIST_SUCCESS;
//     payload: ModuleListSuccess;
// }

// export interface ModuleAddAction {
//     type: ModulesActionTypes.MODULE_ADD;
//     payload: { module_name: string; description: string };
// }

// export interface ModuleAddSuccessAction {
//     type: ModulesActionTypes.MODULE_ADD_SUCCESS;
//     payload: ModuleMessage;
// }

// export interface ModuleDeleteAction {
//     type: ModulesActionTypes.MODULE_DELETE;
//     payload: { module_id: string };
// }

// export interface ModuleDeleteSuccessAction {
//     type: ModulesActionTypes.MODULE_DELETE_SUCCESS;
//     payload: ModuleMessage;
// }

// export interface ModuleUpdateAction {
//     type: ModulesActionTypes.MODULE_UPDATE;
//     payload: { module_id: string; module_name: string; description: string };
// }

// export interface ModuleUpdateSuccessAction {
//     type: ModulesActionTypes.MODULE_UPDATE_SUCCESS;
//     payload: ModuleMessage;
// }

// export interface ModuleUpdateStatusAction {
//     type: ModulesActionTypes.MODULE_UPDATE_STATUS;
//     payload: { module_id: string; is_active: boolean };
// }

// export interface ModuleUpdateStatusSuccessAction {
//     type: ModulesActionTypes.MODULE_UPDATE_STATUS_SUCCESS;
//     payload: ModuleMessage;
// }

// // ---------------- Union ----------------
// export type ModulesAction =
//     | ModuleListAction
//     | ModuleListSuccessAction
//     | ModuleAddAction
//     | ModuleAddSuccessAction
//     | ModuleDeleteAction
//     | ModuleDeleteSuccessAction
//     | ModuleUpdateAction
//     | ModuleUpdateSuccessAction
//     | ModuleUpdateStatusAction
//     | ModuleUpdateStatusSuccessAction;

// // ---------------- Action Creators ----------------
// export const listModules = (payload?: any): ModuleListAction => ({
//     type: ModulesActionTypes.MODULE_LIST,
//     payload,
// });

// export const addModule = (payload: { module_name: string; description: string }): ModuleAddAction => ({
//     type: ModulesActionTypes.MODULE_ADD,
//     payload,
// });

// export const deleteModule = (payload: { module_id: string }): ModuleDeleteAction => ({
//     type: ModulesActionTypes.MODULE_DELETE,
//     payload,
// });

// export const updateModule = (payload: {
//     module_id: string;
//     module_name: string;
//     description: string;
// }): ModuleUpdateAction => ({
//     type: ModulesActionTypes.MODULE_UPDATE,
//     payload,
// });

// export const updateModuleStatus = (payload: { module_id: string; is_active: boolean }): ModuleUpdateStatusAction => ({
//     type: ModulesActionTypes.MODULE_UPDATE_STATUS,
//     payload,
// });

import { ModulesActionTypes } from './constants';

// ---------------- Types ----------------
export interface Module {
    module_id: string;
    module_name: string;
    description: string;
    is_active: boolean;
    created_at?: string;
    updated_at?: string;
}

// Success payloads
export type ModuleListSuccess = Module[];
export type ModuleMessage = { message: string };
export type ModuleError = { error: string };

// ---------------- Action Definitions ----------------
export interface ModuleListAction {
    type: ModulesActionTypes.MODULE_LIST;
    payload?: any; // optional filter params
}

export interface ModuleListSuccessAction {
    type: ModulesActionTypes.MODULE_LIST_SUCCESS;
    payload: ModuleListSuccess;
}

export interface ModuleListErrorAction {
    type: ModulesActionTypes.MODULE_LIST_ERROR;
    payload: ModuleError;
}

export interface ModuleAddAction {
    type: ModulesActionTypes.MODULE_ADD;
    payload: { module_name: string; description: string };
}

export interface ModuleAddSuccessAction {
    type: ModulesActionTypes.MODULE_ADD_SUCCESS;
    payload: ModuleMessage;
}

export interface ModuleAddErrorAction {
    type: ModulesActionTypes.MODULE_ADD_ERROR;
    payload: ModuleError;
}

export interface ModuleDeleteAction {
    type: ModulesActionTypes.MODULE_DELETE;
    payload: { module_id: string };
}

export interface ModuleDeleteSuccessAction {
    type: ModulesActionTypes.MODULE_DELETE_SUCCESS;
    payload: ModuleMessage;
}

export interface ModuleDeleteErrorAction {
    type: ModulesActionTypes.MODULE_DELETE_ERROR;
    payload: ModuleError;
}

export interface ModuleUpdateAction {
    type: ModulesActionTypes.MODULE_UPDATE;
    payload: { module_id: string; module_name: string; description: string };
}

export interface ModuleUpdateSuccessAction {
    type: ModulesActionTypes.MODULE_UPDATE_SUCCESS;
    payload: ModuleMessage;
}

export interface ModuleUpdateErrorAction {
    type: ModulesActionTypes.MODULE_UPDATE_ERROR;
    payload: ModuleError;
}

export interface ModuleUpdateStatusAction {
    type: ModulesActionTypes.MODULE_UPDATE_STATUS;
    payload: { module_id: string; is_active: boolean };
}

export interface ModuleUpdateStatusSuccessAction {
    type: ModulesActionTypes.MODULE_UPDATE_STATUS_SUCCESS;
    payload: ModuleMessage;
}

export interface ModuleUpdateStatusErrorAction {
    type: ModulesActionTypes.MODULE_UPDATE_STATUS_ERROR;
    payload: ModuleError;
}

// ---------------- Union ----------------
export type ModulesAction =
    | ModuleListAction
    | ModuleListSuccessAction
    | ModuleListErrorAction
    | ModuleAddAction
    | ModuleAddSuccessAction
    | ModuleAddErrorAction
    | ModuleDeleteAction
    | ModuleDeleteSuccessAction
    | ModuleDeleteErrorAction
    | ModuleUpdateAction
    | ModuleUpdateSuccessAction
    | ModuleUpdateErrorAction
    | ModuleUpdateStatusAction
    | ModuleUpdateStatusSuccessAction
    | ModuleUpdateStatusErrorAction;

// ---------------- Action Creators ----------------
export const moduleList = (payload?: any): ModuleListAction => ({
    type: ModulesActionTypes.MODULE_LIST,
    payload,
});

export const moduleAdd = (payload: {
    module_name: string;
    description: string;
    base_price: string;
    module_key: string;
}): ModuleAddAction => ({
    type: ModulesActionTypes.MODULE_ADD,
    payload,
});

export const moduleDelete = (payload: { module_id: string }): ModuleDeleteAction => ({
    type: ModulesActionTypes.MODULE_DELETE,
    payload,
});

export const moduleUpdate = (payload: {
    module_id: string;
    module_name: string;
    description: string;
    base_price: string;
}): ModuleUpdateAction => ({
    type: ModulesActionTypes.MODULE_UPDATE,
    payload,
});

export const moduleUpdateStatus = (payload: { module_id: string; is_active: boolean }): ModuleUpdateStatusAction => ({
    type: ModulesActionTypes.MODULE_UPDATE_STATUS,
    payload,
});
